import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
  Edit,
} from "@syncfusion/ej2-react-grids";
import { Modal } from "antd";
import { useBarcodeStore } from "../../../store/useBarcodeMasterStore";
import { updateAgingStoreApi } from "../../../services/barCodeMaster";

const BasicGrid = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [gridData, setGridData] = useState([]);
  const [editingRowId, setEditingRowId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const { allList } = useBarcodeStore();
  useEffect(() => {
    if (allList?.length) {
      const formattedData = allList.map((item, index) => ({
        ...item,
        serialNo: index + 1,

        PopulatedDate: item.PopulatedDate ? new Date(item.PopulatedDate) : null,

        ManufactureDate: item.ManufactureDate
          ? new Date(item.ManufactureDate)
          : null,

        UploadedOn: item.UploadedOn ? new Date(item.UploadedOn) : null,
      }));

      setGridData(formattedData);
    } else {
      setGridData([]);
    }
  }, [allList]);

  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="BrokerGrid"
              dataSource={gridData}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"300px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
              allowResizing={true}
              dataBound={() => {
                if (!isMobile && gridInstance) {
                  gridInstance.autoFitColumns();
                }
              }}
              // frozenColumns={1}

              // rowDataBound={()}
              // commandClick={handleCommandClick}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="90"
                  textAlign="Center"
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="Id"
                  headerText="Id"
                  width="90"
                  textAlign="Center"
                  visible={false}
                />
                <ColumnDirective
                  field="PopulatedDate"
                  headerText="Populated Date"
                  width="180"
                  type="date"
                  format="dd/MM/yyyy"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="StoreCode"
                  headerText="Store Code"
                  width="180"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="StoreName"
                  headerText="Store Name"
                  width="250"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="ItemCode"
                  headerText="Item Code"
                  width="200"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="ShortDesc"
                  headerText="Short Desc"
                  width="250"
                  textAlign="Left"
                  allowEditing={false}
                />

                <ColumnDirective
                  field="DivisionName"
                  headerText="Division Name"
                  width="180"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="GrnBucket"
                  headerText="Grn Bucket"
                  width="180"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="SOH"
                  headerText="SOH"
                  width="150"
                  textAlign="Left"
                  allowEditing={false}
                />

                <ColumnDirective
                  field="Total_SOH"
                  headerText="Total SOH"
                  width="150"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="ManufactureDate"
                  headerText="Manufacture Date"
                  width="250"
                  type="date"
                  format="dd/MM/yyyy"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="DiscountPer"
                  headerText="Discount Per"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="Mrp"
                  headerText="MRP"
                  width="150"
                  textAlign="Left"
                  allowEditing={false}
                />

                <ColumnDirective
                  field="UploadedOn"
                  headerText="Uploaded On"
                  width="180"
                  textAlign="Left"
                  type="date"
                  format="dd/MM/yyyy"
                />
              </ColumnsDirective>

              <Inject
                services={[
                  Edit,
                  CommandColumn,
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                  Freeze,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>

      <Modal
        open={isModalOpen}
        footer={[
          <div
            key="ok-btn"
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <button
              onClick={() => setIsModalOpen(false)}
              style={{
                padding: "8px 28px",
                backgroundColor: "#1677ff",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>,
        ]}
        closable={false} // ❌ remove top-right X
        centered
      >
        <p
          style={{
            fontSize: "25px", // text bada
            color: "#333",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          {modalMsg}
        </p>
      </Modal>
    </>
  );
};

export default BasicGrid;
